import VmpIconText from './src/main';

/* istanbul ignore next */
VmpIconText.install = function (Vue) {
  Vue.component(VmpIconText.name, VmpIconText);
};

export default VmpIconText;
